// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-header {
    padding: 10px;
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    height: 80px;
    border-bottom: 1px solid #CDCDCD;
}

.back-button {
    width: 33%;
}

.header-buttons {
    display: flex;
    width: 33%;
    justify-content: flex-end;
}

.header-image {
    width: 33%;
    display: flex;
    align-items: center !important;
    justify-content: center !important;
}

.header-image img {
    width: 125px;
    height: 38px;
}

.header-back-button .ant-btn {
    padding: 12px 40px !important;
    height: auto !important;
    border-radius: 6px !important;
    margin-right: 10px;
}

.upload-file-btn {
    padding: 6px;
    height: 32px;
    width: 90px;
    border-radius: 6px !important;
    margin-top: 10px;
    color: #7EA0CF;
    border: 1px solid #7EA0CF;
    font-size: 12px;
    text-align: center;
    cursor: pointer;
    z-index: 11111111;
}

.upload-file-btn input {
    width: 90px;
    height: 32px;
    bottom: 20px;
    position: relative;
    font-size: 0;
    opacity: 0;
    cursor: pointer !important;
}

.header-save-button .ant-btn {
    background: rgba(66, 115, 184, 1) !important;
    padding: 12px 30px !important;
    height: auto !important;
    border-radius: 6px !important;
    color: white !important;
}

.chat-container {
    display: flex;
}

.chat-left-column {
    width: 50%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 80px);
    overflow: auto;
    border-right: 1px solid #CDCDCD;
}

.configure-tab {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0;
}

.configure-tab div {
    background-color: #BBCDE5;
    width: 250px;
    border-radius: 4px;
    padding: 4px 6px;
    height: 42px;
    display: flex;
    justify-content: space-between;
}

.configure-button {
    background-color: #BBCDE5;
    color: #6089C3;
    padding: 8px;
    font-weight: 400;
    font-size: 16px;
    width: 100%;
    padding: 5px 8px;
    text-align: center;
    cursor: pointer;
}

.configure-button-active {
    background-color: #fff;
    color: #37619B;
    border: 1px solid #37619B;
    font-size: 16px;
    padding: 4px 8px;
    font-weight: 500;
    border-radius: 6px;
    width: 100%;
    /* height: 38px; */
    cursor: pointer;
    text-align: center;
}

.chat-right-column {
    width: 50%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 80px);
    overflow: auto;
}

.chatbot-container {
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: auto;
    padding: 0 5px;
}

.chat-row {
    border-bottom: 1px solid #CDCDCD;
    margin-top: 20px;
    display: flex;
    align-items: flex-start;
}


.business-text {
    margin-top: 30px;
    margin-left: 50px;
    font-size: 12;
}

.chat_card_image {
    width: 28px;
    height: 28px;
}

.chat-row-left {
    width: 10%;
    padding: 25px;
    padding-top: 15px;
    padding-left: 50px;
}

.chat-row-right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    float: left !important;
    width: 85%;
    padding-left: 10px;
    min-height: 115px;
}

.configure-chat-container {
    padding: 25px;
    padding-top: 0;
    padding-left: 50px;
}

.logo-text {
    font-weight: 500;
    font-size: 16px;
    margin-left: 5px;
    color: #4E4E4E;
}

.input-container {
    display: flex;
    flex-direction: column;
    margin: 22px 0;
}

.input-container p {
    font-size: 16px;
    font-weight: 300;
    color: #4E4E4E;
    padding: 5px;
}

.upload-logo {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #7EA0CF;
}

.input-container input {
    border-radius: 8px;
    height: 54px;
}

.theme-color {
    display: flex;
}

.theme-input {
    width: 114px;
    margin-right: 10px;

}

.upload-plus {
    color: #37619B;
    font-size: 30px;
    position: relative;
    left: 40%;
    top: 3%;
}

.upload-logo-btn {
    opacity: 0;
    position: relative;
    z-index: 1;
    top: 12%;
    right: 10%;
    height: 100%;
    width: 100%;
}



/* .add-question-btn {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    margin-left: 10px;
    background-color: #ffff;
    color: #37619B;
    border: 1px solid #37619B;
    text-align: center;
    cursor: pointer;
} */

/* .remove-question-btn {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    margin-left: 10px;
    margin-bottom: 5px;
    background-color: #37619B;
    border: 1px solid #37619B;
    text-align: center;
    cursor: pointer;
} */

.remove-question-btn h6 {
    color: #fff;
}

.add-question-btn h3 {
    color: #37619B;
}

.file-preview-container {
    border-radius: 8px;
    box-shadow: inset 0px 0px 10px #A3A3A326;
    height: auto;
    padding: 10px;
    display: flex;
    justify-content: flex-start;
    overflow: scroll;
    flex-wrap: wrap;
    flex-direction: row;
    overflow: auto !important;

}

.file-preview {
    width: 160px;
    margin: 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px;
    padding: 8px;
    border: 1px solid #CDCDCD;
}

.file-preview-name {
    display: flex;
    line-height: 1.1;
    justify-content: center;
    flex-direction: column;
    width: calc(100% - 30px);
}

.file-preview-name span {
    color: #4E4E4E;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100px;
}

.file-preview img {
    width: 26px;
    height: 30px;
}

/* .chat-row-right h5 {
    color: #424242 !important;
} */

.preview-header {
    width: 100%;
    margin-top: 20px;
    text-align: center;
}

.docs_custom_chat_main_div {
    position: fixed;
    height: 100%;
    width: 25%;
    /* z-index: 9999999; */
}

.docs_custom_chat_body_div {
    height: calc(100vh - 235px);
    overflow-y: auto;
    padding-top: 10px;
    display: flex;
    flex-direction: column;
}

input[type="color"] {
    border-radius: 5px;
    padding: 2px;
}

input[type="color"]::-moz-color-swatch {
    border: none;
}

input[type="color"]::-webkit-color-swatch-wrapper {
    padding: 0;
    border-radius: 0;
}

input[type="color"]::-webkit-color-swatch {
    border: none;
}

@media screen and (max-width: 1100px) {
    .chat-container {
        flex-direction: column-reverse;
    }

    .chat-left-column,
    .chat-right-column {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/Screens/Chatbot/Chatbot.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,4CAA4C;IAC5C,6BAA6B;IAC7B,uBAAuB;IACvB,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B;IAC1B,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;;;AAGA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,UAAU;IACV,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;;AAEtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,OAAO;AACX;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,WAAW;AACf;;;;AAIA;;;;;;;;;;GAUG;;AAEH;;;;;;;;;;GAUG;;AAEH;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,wCAAwC;IACxC,YAAY;IACZ,aAAa;IACb,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;;AAE7B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;GAEG;;AAEH;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,8BAA8B;IAClC;;IAEA;;QAEI,WAAW;IACf;AACJ","sourcesContent":[".chat-header {\n    padding: 10px;\n    display: flex;\n    /* justify-content: space-between; */\n    align-items: center;\n    height: 80px;\n    border-bottom: 1px solid #CDCDCD;\n}\n\n.back-button {\n    width: 33%;\n}\n\n.header-buttons {\n    display: flex;\n    width: 33%;\n    justify-content: flex-end;\n}\n\n.header-image {\n    width: 33%;\n    display: flex;\n    align-items: center !important;\n    justify-content: center !important;\n}\n\n.header-image img {\n    width: 125px;\n    height: 38px;\n}\n\n.header-back-button .ant-btn {\n    padding: 12px 40px !important;\n    height: auto !important;\n    border-radius: 6px !important;\n    margin-right: 10px;\n}\n\n.upload-file-btn {\n    padding: 6px;\n    height: 32px;\n    width: 90px;\n    border-radius: 6px !important;\n    margin-top: 10px;\n    color: #7EA0CF;\n    border: 1px solid #7EA0CF;\n    font-size: 12px;\n    text-align: center;\n    cursor: pointer;\n    z-index: 11111111;\n}\n\n.upload-file-btn input {\n    width: 90px;\n    height: 32px;\n    bottom: 20px;\n    position: relative;\n    font-size: 0;\n    opacity: 0;\n    cursor: pointer !important;\n}\n\n.header-save-button .ant-btn {\n    background: rgba(66, 115, 184, 1) !important;\n    padding: 12px 30px !important;\n    height: auto !important;\n    border-radius: 6px !important;\n    color: white !important;\n}\n\n.chat-container {\n    display: flex;\n}\n\n.chat-left-column {\n    width: 50%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: calc(100vh - 80px);\n    overflow: auto;\n    border-right: 1px solid #CDCDCD;\n}\n\n.configure-tab {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 20px 0;\n}\n\n.configure-tab div {\n    background-color: #BBCDE5;\n    width: 250px;\n    border-radius: 4px;\n    padding: 4px 6px;\n    height: 42px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.configure-button {\n    background-color: #BBCDE5;\n    color: #6089C3;\n    padding: 8px;\n    font-weight: 400;\n    font-size: 16px;\n    width: 100%;\n    padding: 5px 8px;\n    text-align: center;\n    cursor: pointer;\n}\n\n.configure-button-active {\n    background-color: #fff;\n    color: #37619B;\n    border: 1px solid #37619B;\n    font-size: 16px;\n    padding: 4px 8px;\n    font-weight: 500;\n    border-radius: 6px;\n    width: 100%;\n    /* height: 38px; */\n    cursor: pointer;\n    text-align: center;\n}\n\n.chat-right-column {\n    width: 50%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: calc(100vh - 80px);\n    overflow: auto;\n}\n\n.chatbot-container {\n    width: 100%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    overflow: auto;\n    padding: 0 5px;\n}\n\n.chat-row {\n    border-bottom: 1px solid #CDCDCD;\n    margin-top: 20px;\n    display: flex;\n    align-items: flex-start;\n}\n\n\n.business-text {\n    margin-top: 30px;\n    margin-left: 50px;\n    font-size: 12;\n}\n\n.chat_card_image {\n    width: 28px;\n    height: 28px;\n}\n\n.chat-row-left {\n    width: 10%;\n    padding: 25px;\n    padding-top: 15px;\n    padding-left: 50px;\n}\n\n.chat-row-right {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    float: left !important;\n    width: 85%;\n    padding-left: 10px;\n    min-height: 115px;\n}\n\n.configure-chat-container {\n    padding: 25px;\n    padding-top: 0;\n    padding-left: 50px;\n}\n\n.logo-text {\n    font-weight: 500;\n    font-size: 16px;\n    margin-left: 5px;\n    color: #4E4E4E;\n}\n\n.input-container {\n    display: flex;\n    flex-direction: column;\n    margin: 22px 0;\n}\n\n.input-container p {\n    font-size: 16px;\n    font-weight: 300;\n    color: #4E4E4E;\n    padding: 5px;\n}\n\n.upload-logo {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #7EA0CF;\n}\n\n.input-container input {\n    border-radius: 8px;\n    height: 54px;\n}\n\n.theme-color {\n    display: flex;\n}\n\n.theme-input {\n    width: 114px;\n    margin-right: 10px;\n\n}\n\n.upload-plus {\n    color: #37619B;\n    font-size: 30px;\n    position: relative;\n    left: 40%;\n    top: 3%;\n}\n\n.upload-logo-btn {\n    opacity: 0;\n    position: relative;\n    z-index: 1;\n    top: 12%;\n    right: 10%;\n    height: 100%;\n    width: 100%;\n}\n\n\n\n/* .add-question-btn {\n    width: 24px;\n    height: 24px;\n    border-radius: 4px;\n    margin-left: 10px;\n    background-color: #ffff;\n    color: #37619B;\n    border: 1px solid #37619B;\n    text-align: center;\n    cursor: pointer;\n} */\n\n/* .remove-question-btn {\n    width: 24px;\n    height: 24px;\n    border-radius: 4px;\n    margin-left: 10px;\n    margin-bottom: 5px;\n    background-color: #37619B;\n    border: 1px solid #37619B;\n    text-align: center;\n    cursor: pointer;\n} */\n\n.remove-question-btn h6 {\n    color: #fff;\n}\n\n.add-question-btn h3 {\n    color: #37619B;\n}\n\n.file-preview-container {\n    border-radius: 8px;\n    box-shadow: inset 0px 0px 10px #A3A3A326;\n    height: auto;\n    padding: 10px;\n    display: flex;\n    justify-content: flex-start;\n    overflow: scroll;\n    flex-wrap: wrap;\n    flex-direction: row;\n    overflow: auto !important;\n\n}\n\n.file-preview {\n    width: 160px;\n    margin: 2px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: 8px;\n    padding: 8px;\n    border: 1px solid #CDCDCD;\n}\n\n.file-preview-name {\n    display: flex;\n    line-height: 1.1;\n    justify-content: center;\n    flex-direction: column;\n    width: calc(100% - 30px);\n}\n\n.file-preview-name span {\n    color: #4E4E4E;\n    font-weight: 400;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100px;\n}\n\n.file-preview img {\n    width: 26px;\n    height: 30px;\n}\n\n/* .chat-row-right h5 {\n    color: #424242 !important;\n} */\n\n.preview-header {\n    width: 100%;\n    margin-top: 20px;\n    text-align: center;\n}\n\n.docs_custom_chat_main_div {\n    position: fixed;\n    height: 100%;\n    width: 25%;\n    /* z-index: 9999999; */\n}\n\n.docs_custom_chat_body_div {\n    height: calc(100vh - 235px);\n    overflow-y: auto;\n    padding-top: 10px;\n    display: flex;\n    flex-direction: column;\n}\n\ninput[type=\"color\"] {\n    border-radius: 5px;\n    padding: 2px;\n}\n\ninput[type=\"color\"]::-moz-color-swatch {\n    border: none;\n}\n\ninput[type=\"color\"]::-webkit-color-swatch-wrapper {\n    padding: 0;\n    border-radius: 0;\n}\n\ninput[type=\"color\"]::-webkit-color-swatch {\n    border: none;\n}\n\n@media screen and (max-width: 1100px) {\n    .chat-container {\n        flex-direction: column-reverse;\n    }\n\n    .chat-left-column,\n    .chat-right-column {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
